import {
    IS_LOADING,
    IS_LOADINGINTRO,
    IS_LOADINGFRIST
} from '../actionTypes';

const INIT_STATE = {
    type : false,
    typeintro : true,
    loadingfrist : false
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case IS_LOADING:
            return {...state, type: action.payload};
        case IS_LOADINGINTRO:
            return {...state, typeintro: action.payload};
        case IS_LOADINGFRIST:
            return {...state, loadingfrist: action.payload};
        default:
            return {...state};
    }
};
